import React from 'react';

const GOLD = '#C8A84B';
const GOLD_BORDER = 'rgba(200,168,75,0.25)';
const NAVY = "#FBF7EE";

const S = {
  page: { display:'flex', flexDirection:'column', minHeight:'calc(100vh - 57px)', background:"#FBF7EE", fontFamily:"'DM Sans','Segoe UI',sans-serif" },
  header: { display:'flex', alignItems:'center', gap:12, padding:'12px 20px', borderBottom:'1px solid rgba(200,168,75,0.2)', background:'rgba(6,9,30,0.97)', flexShrink:0 },
  back: { background:'none', border:'none', color:'rgba(200,168,75,0.5)', fontSize:14, cursor:'pointer', fontWeight:600, padding:0 },
  avatar: { width:34, height:34, borderRadius:'50%', background:'rgba(200,168,75,0.12)', border:'1px solid rgba(200,168,75,0.3)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:16, fontWeight:800, color:GOLD, fontFamily:"'Cinzel',serif" },
  info: { flex:1, minWidth:0 },
  name: { fontWeight:800, fontSize:13, letterSpacing:'0.1em', color:'#ffffff', fontFamily:"'Cinzel',serif" },
  status: { fontSize:11, color:'rgba(200,168,75,0.5)', display:'flex', alignItems:'center', gap:4, marginTop:2, fontStyle:'italic', fontFamily:"'Cormorant Garamond',Georgia,serif" },
  statusDot: { width:5, height:5, borderRadius:'50%', background:GOLD, flexShrink:0 },
  body: { flex:1, overflowY:'auto', padding:'28px 20px 60px', maxWidth:680, margin:'0 auto', width:'100%' },
  eyebrow: (color) => ({ fontSize:10, fontWeight:700, letterSpacing:'2px', color, marginBottom:12, fontFamily:"'Cinzel',serif", textTransform:'uppercase' }),
  lessonTitle: { fontSize:'clamp(20px,3vw,28px)', fontWeight:800, color:'#ffffff', lineHeight:1.2, marginBottom:12, fontFamily:"'Cinzel',serif", letterSpacing:'0.02em' },
  lessonDesc: { fontSize:17, color:'rgba(26,20,8,0.5)', lineHeight:1.8, marginBottom:20, fontFamily:"'Cormorant Garamond',Georgia,serif", fontStyle:'italic' },
  pills: { display:'flex', gap:8, flexWrap:'wrap', marginBottom:24 },
  pill: (color) => ({ fontSize:10, fontWeight:600, color, background:color+'12', border:'1px solid '+color+'30', padding:'4px 12px', borderRadius:20, fontFamily:"'Cinzel',serif", letterSpacing:'0.5px' }),
  divider: { height:1, background:'linear-gradient(to right,transparent,rgba(200,168,75,0.2),transparent)', margin:'20px 0' },
  teachSection: { marginBottom:24 },
  teachHeading: { fontSize:14, fontWeight:700, color:'#ffffff', marginBottom:10, display:'flex', alignItems:'center', gap:8, fontFamily:"'Cinzel',serif", letterSpacing:'0.03em' },
  teachDot: (color) => ({ width:5, height:5, borderRadius:'50%', background:color, flexShrink:0 }),
  teachBody: { fontSize:15, color:'rgba(26,20,8,0.6)', lineHeight:1.85, whiteSpace:'pre-line', fontFamily:"'Cormorant Garamond',Georgia,serif" },
  challengeBox: { background:'rgba(200,168,75,0.05)', border:'1px solid rgba(200,168,75,0.25)', borderLeft:'3px solid #C8A84B', borderRadius:12, padding:'20px', marginBottom:28 },
  challengeLabel: { fontSize:9, fontWeight:700, letterSpacing:'2px', color:GOLD, marginBottom:10, fontFamily:"'Cinzel',serif", textTransform:'uppercase' },
  challengeText: { fontSize:15, color:'rgba(26,20,8,0.7)', lineHeight:1.75, fontFamily:"'Cormorant Garamond',Georgia,serif" },
  claudeBtn: { width:'100%', padding:'16px', borderRadius:12, background:'linear-gradient(135deg,#C8A84B,#D4B85A)', border:'none', color:NAVY, fontSize:15, fontWeight:800, cursor:'pointer', letterSpacing:'0.06em', fontFamily:"'Cinzel',serif", display:'flex', alignItems:'center', justifyContent:'center', gap:10, marginBottom:12 },
  claudeNote: { textAlign:'center', fontSize:12, color:'rgba(200,168,75,0.4)', lineHeight:1.6, fontFamily:"'Cormorant Garamond',Georgia,serif", fontStyle:'italic' },
  completeBtn: { width:'100%', padding:'13px', borderRadius:12, background:'transparent', border:'1px solid rgba(74,222,128,0.3)', color:'#4ade80', fontSize:13, fontWeight:700, cursor:'pointer', marginTop:16, letterSpacing:'0.5px', fontFamily:"'Cinzel',serif" },
  coachPage: { flex:1, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'40px 24px', textAlign:'center' },
  coachEmoji: { fontSize:48, marginBottom:20 },
  coachTitle: { fontSize:22, fontWeight:800, color:'#ffffff', marginBottom:12, fontFamily:"'Cinzel',serif", letterSpacing:'0.04em' },
  coachDesc: { fontSize:16, color:'rgba(26,20,8,0.45)', lineHeight:1.75, marginBottom:36, maxWidth:400, fontFamily:"'Cormorant Garamond',Georgia,serif", fontStyle:'italic' },
  promptCards: { display:'flex', flexDirection:'column', gap:10, width:'100%', maxWidth:440, marginBottom:36 },
  promptCard: { background:'rgba(200,168,75,0.04)', border:'1px solid rgba(200,168,75,0.2)', borderRadius:10, padding:'14px 16px', textAlign:'left' },
  promptLabel: { fontSize:9, color:GOLD, marginBottom:6, fontWeight:700, letterSpacing:'1.5px', fontFamily:"'Cinzel',serif", textTransform:'uppercase' },
  promptText: { fontSize:13, color:'rgba(26,20,8,0.5)', lineHeight:1.6, fontFamily:"'Cormorant Garamond',Georgia,serif", fontStyle:'italic' },
};

export default function LessonChat({ lesson, track, onBack, onComplete }) {
  const openClaude = () => window.open('https://claude.ai', '_blank');

  if (!lesson || !track) {
    return (
      <div style={S.page}>
        <div style={S.header}>
          <button style={S.back} onClick={onBack}>← Back</button>
          <div style={S.avatar}>A</div>
          <div style={S.info}>
            <div style={S.name}>ARIA</div>
            <div style={S.status}><span style={S.statusDot}/>Artificial Intelligence Resource and Instruction Academy</div>
          </div>
        </div>
        <div style={S.coachPage}>
          <div style={S.coachEmoji}>🤖</div>
          <div style={S.coachTitle}>Your ARIA Coach Lives in Claude</div>
          <div style={S.coachDesc}>ARIA is your personal AI coach — built inside Claude using the companion prompt from Module 1 Lesson 1. Open Claude to talk to her anytime.</div>
          <div style={S.promptCards}>
            <div style={S.promptCard}>
              <div style={S.promptLabel}>Track A — I have an idea</div>
              <div style={S.promptText}>"ARIA, I just finished [lesson name]. My project is [your idea]. Help me apply what I just learned."</div>
            </div>
            <div style={S.promptCard}>
              <div style={S.promptLabel}>Track B — Still finding mine</div>
              <div style={S.promptText}>"ARIA, I just finished [lesson name]. Based on what we have discussed, what audience do you think I am drawn to?"</div>
            </div>
            <div style={S.promptCard}>
              <div style={S.promptLabel}>Practice Roleplay</div>
              <div style={S.promptText}>"ARIA, roleplay as a [client type] so I can practice my discovery session."</div>
            </div>
          </div>
          <button style={S.claudeBtn} onClick={openClaude}>Open ARIA in Claude →</button>
          <div style={S.claudeNote}>Don't have ARIA set up yet? Complete Module 1 Lesson 1 first.<br/>The companion prompt is in your 08 — Resources folder.</div>
        </div>
      </div>
    );
  }

  return (
    <div style={S.page}>
      <div style={S.header}>
        <button style={S.back} onClick={onBack}>← Back</button>
        <div style={S.avatar}>A</div>
        <div style={S.info}>
          <div style={S.name}>ARIA Academy</div>
          <div style={S.status}><span style={S.statusDot}/>{track.emoji} {track.title.replace(/^Module \d+ — /,'')}</div>
        </div>
      </div>
      <div style={S.body}>
        <div style={S.eyebrow(track.color)}>{track.emoji} Module {track.title.match(/\d+/)?.[0]} · Lesson {lesson.num}</div>
        <div style={S.lessonTitle}>{lesson.title}</div>
        <div style={S.lessonDesc}>{lesson.description}</div>
        <div style={S.pills}>
          <span style={S.pill(track.color)}>⏱ {lesson.duration}</span>
          <span style={S.pill(track.color)}>{lesson.type}</span>
          <span style={S.pill('#4ade80')}>+{lesson.xp} XP</span>
          <span style={S.pill('rgba(26,20,8,0.4)')}>🏅 {lesson.keySkill}</span>
        </div>
        <div style={S.divider} />
        {lesson.teaching && lesson.teaching.map((section, i) => (
          <div key={i} style={S.teachSection}>
            <div style={S.teachHeading}>
              <span style={S.teachDot(track.color)} />
              {section.heading}
            </div>
            <div style={S.teachBody}>{section.body}</div>
            {i < lesson.teaching.length - 1 && <div style={S.divider} />}
          </div>
        ))}
        <div style={S.divider} />
        <div style={S.challengeBox}>
          <div style={S.challengeLabel}>🤖 Do This in Claude — Your Challenge</div>
          <div style={S.challengeText}>{lesson.challenge}</div>
        </div>
        <button style={S.claudeBtn} onClick={openClaude}>Open ARIA in Claude →</button>
        <div style={S.claudeNote}>Copy your challenge · Open Claude · Talk to ARIA<br/>Come back and mark complete when you are done.</div>
        <button style={S.completeBtn} onClick={() => onComplete(lesson)}>✓ Mark This Lesson Complete</button>
      </div>
    </div>
  );
}
